import { Currency } from 'shared/api/fetchTariffs';

const CURRENCY_SYMBOL: Record<Currency, string> = {
  USD: '$',
  RUB: '₽',
  INR: '₹',
};

export const formatTariffPrice = (
  amount: number,
  currency: Currency,
  prefix = ''
): string => `${prefix}${amount}${CURRENCY_SYMBOL[currency]}`;
